export default __webpack_public_path__ + "static/media/visa.bc7d4e67.png";